import { Rechnungsperson } from "./rechnungsperson"

export class Rechnungsempfaenger {
    empfaenger = new Rechnungsperson(true)
}
